import React from "react";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { EMPTY_STRING, surveyFiledsTypes } from "../../../constants";

const { TYPE_RADIO, TYPE_TEXT } = surveyFiledsTypes;

const SurveyFormField = ({
  variant = TYPE_TEXT,
  type = TYPE_TEXT,
  name = EMPTY_STRING,
  label = EMPTY_STRING,
  value = EMPTY_STRING,
  endAdornment = null,
  placeHolder = EMPTY_STRING,
  multiple = false, // Enable multiple selection
  onChange = null,
  textValue = EMPTY_STRING,
  isDisabled,
}) => {
  const { register, watch, setValue } = useFormContext();

  // Watch the current value of the field

  const selectedValue = watch(name);

  // Handle option click for single and multiple selections
  const handleOptionClick = () => {
    if (multiple) {
      // For multiple selections
      const currentValues = selectedValue || []; // Default to empty array if undefined

      if (currentValues.includes(value)) {
        // If the label is already selected, remove it
        setValue(
          name,
          currentValues.filter((values) => values !== value) // Remove the item from the array
        );
      } else {
        // If the label is not selected, add it
        setValue(name, [...currentValues, value]); // Add the item to the array
      }
    } else {
      // For single selection
      setValue(name, value);
    }
  };

  if (variant === TYPE_TEXT) {
    return (
      <div className="position-relative">
        <input
          {...(name ? register(name) : {})}
          {...(onChange ? { onChange } : {})}
          {...(textValue ? { value: textValue } : {})}
          type={type}
          className={`survey-form-field ${
            endAdornment ? "pe-4" : EMPTY_STRING
          }`}
          autoComplete="off"
          placeholder={placeHolder}
          disabled={isDisabled}
        />
        {endAdornment}
      </div>
    );
  } else if (variant === TYPE_RADIO) {
    return (
      <div
        className="position-relative"
        onClick={handleOptionClick} // Clicking the parent div triggers selection
        style={{ cursor: "pointer" }}
      >
        <div
          className={`survey-radio-input ${
            multiple
              ? selectedValue?.includes(value)
                ? "survey-radio-input-selected" // Selected styling for multiple
                : EMPTY_STRING
              : selectedValue === value
              ? "survey-radio-input-selected" // Selected styling for single
              : EMPTY_STRING
          }`}
        >
          <Form.Check
            name={name + value}
            value={value}
            type={variant}
            label={label}
            checked={
              multiple
                ? selectedValue?.includes(value) // Check if option is selected
                : selectedValue === value // For single selection
            }
            readOnly // Prevent direct change from radio button
          />
        </div>
        {endAdornment}
      </div>
    );
  }
  return <></>;
};

export default SurveyFormField;
